// extracted by mini-css-extract-plugin
export default {"header":"styles_header__UHngP","headerInfo":"styles_headerInfo__keNBd"};